import React from "react";
import { Box, Typography } from "@mui/material";
import { CardLayout } from "../v3";

import { WORKER_AVATAR, VENDOR_AVATAR, CLIENT_AVATAR, EMPLOYEE_AVATAR, SUBCONTRACTOR_AVATAR } from "../../utils/image.constants";

const BALANCE_ITEMS = [
  { key: "workers", label: "Workers", avatar: WORKER_AVATAR },
  { key: "vendors", label: "Vendors", avatar: VENDOR_AVATAR },
  { key: "clients", label: "Clients", avatar: CLIENT_AVATAR },
  { key: "employees", label: "Employees", avatar: EMPLOYEE_AVATAR },
  { key: "subcontractors", label: "Subcontractors", avatar: SUBCONTRACTOR_AVATAR },
];

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "—";
  return Number(value).toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
};

export const OverviewCard = ({ label = "Orders", value = "1,235", icon = null, iconBg = "#674BF5" }) => {
  return (
    <CardLayout
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 14px",
        minWidth: 140,
        margin: "11px",
      }}
    >
      <Box>
        <Typography variant="caption" sx={{ color: "#888", fontWeight: 500, mb: 0.25 }}>
          {label}
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {value}
        </Typography>
      </Box>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          backgroundColor: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
        }}
      >
        {icon && React.cloneElement(icon, { sx: { fontSize: 18 } })}
      </Box>
    </CardLayout>
  );
};

export const BalanceSummaryCard = ({ balanceSummary = {} }) => {
  return (
    <CardLayout sx={{ margin: "11px" }}>
      <Typography variant="caption" sx={{ fontWeight: 700, color: "#674BF5", display: "block", mb: 1.5 }}>
        Balance Summary
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {BALANCE_ITEMS.map(({ key, label, avatar }) => {
          const balance = balanceSummary?.[`${key}Balance`];
          const advance = balanceSummary?.[`${key}Advance`];
          return (
            <Box
              key={key}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                py: 0.75,
                px: 1,
                borderRadius: 1.5,
                backgroundColor: "#FAFAFA",
              }}
            >
              <Box
                component="img"
                src={avatar}
                alt={label}
                sx={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" fontWeight={600} sx={{ display: "block", lineHeight: 1.3 }}>
                  {label}
                </Typography>
                <Box sx={{ display: "flex", gap: 2, mt: 0.25 }}>
                  <Typography variant="caption" color="text.secondary">
                    Bal: <strong style={{ color: "#1B5E20" }}>{formatCurrency(balance)}</strong>
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Adv: <strong style={{ color: "#E65100" }}>{formatCurrency(advance)}</strong>
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </CardLayout>
  );
};
